module.exports = __webpack_public_path__ + "static/img/printNotice.4d60dcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/printNotice.png
// module id = A8yH
// module chunks = 2